import React from 'react';
import { Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import '../../styles/forwarding.css'; // Import specific CSS for styling
import '../../styles/Fonts.css'; // Import font styling if needed

const faqData = [
  {
    question: 'What forwarding services do you provide?',
    answer: (
      <p className='poppins-regular text-start'>
        We offer comprehensive forwarding services including air freight, sea freight, land transport, and multimodal solutions. 
        Our services cover both domestic and international shipments with full documentation handling.
      </p>
    ),
  },
  {
    question: 'Do you handle customs clearance and documentation?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, we provide complete customs brokerage services and handle all necessary documentation for international shipments. 
        Our experienced team ensures compliance with all customs regulations and requirements.
      </p>
    ),
  },
  {
    question: 'What are your international forwarding capabilities?',
    answer: (
      <p className='poppins-regular text-start'>
        We have a global network of partners enabling us to handle shipments to and from major destinations worldwide. 
        Our international forwarding services include air and sea freight with door-to-door delivery options.
      </p>
    ),
  },
  {
    question: 'How do you ensure cargo security during forwarding?',
    answer: (
      <p className='poppins-regular text-start'>
        We implement comprehensive security measures including cargo insurance, secure handling protocols, and real-time tracking. 
        Our forwarding process includes multiple checkpoints to ensure your cargo's safety throughout transit.
      </p>
    ),
  },
];

const ForwardingFAQ = () => {
  return (
    <section id="faq" className="forwarding-faq-section">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-badge">HAVE QUESTIONS?</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-description">
            Get answers to common questions about our forwarding services and processes.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Accordion>
              {faqData.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>
                    <h5 className="mb-0">{faq.question}</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForwardingFAQ;
